/**
 * Created by Administrador on 03/05/2018.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('forgotService', forgotService);

    forgotService.$inject = ['$http', 'CONFIG', 'messageService'];

    function forgotService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/users';
        var urlBasePublic = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.PUBLIC + '/users';
        var service = {
            forgotPassword: forgotPassword,
            thereEmail: thereEmail
        };

        return service;

        function forgotPassword(email, url, domainId, accessToken){
            var options = angular.extend({
                headers: {
                    'Content-Type':  'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + accessToken,
                    AuthorizationBasic: btoa(CONFIG.CLIENT_ID_AIR + ':' + CONFIG.SECRET_AIR)
                }
            }, options);

            return $http.put(urlBasePublic + "/forgotPassword/" + email +'?url='+url+'&domainId='+domainId, null, options)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('');
                });
        }
        function thereEmail(email){
            return $http.get(urlBasePublic + "/thereEmail/" + email, {headers: {'Loading-Overlay': false}});
        }
    }
})();
